import {
  LayoutTemplate,
  Shapes,
  Type,
  Palette,
  Upload,
  Wrench,
  FolderOpen,
  AppWindow,
} from "lucide-react";

const TABS = [
  { id: "templates", label: "Templates", icon: LayoutTemplate },
  { id: "elements", label: "Elements", icon: Shapes },
  { id: "text", label: "Text", icon: Type },
  { id: "brand", label: "Brand", icon: Palette },
  { id: "uploads", label: "Uploads", icon: Upload },
  { id: "tools", label: "Tools", icon: Wrench },
  { id: "projects", label: "Projects", icon: FolderOpen },
  { id: "apps", label: "Apps", icon: AppWindow },
];

export default function LeftSidebar({ active, onChange }) {
  return (
    <aside
      className="w-[72px] bg-white border-r border-gray-200 flex flex-col items-center py-3 gap-1 z-40 shrink-0 overflow-y-auto ch-scroll"
      data-testid="left-sidebar"
    >
      {TABS.map((t) => {
        const Icon = t.icon;
        return (
          <button
            key={t.id}
            className={`ch-tab ${active === t.id ? "active" : ""}`}
            onClick={() => onChange(t.id)}
            data-testid={`sidebar-tab-${t.id}`}
            title={t.label}
          >
            <Icon className="w-5 h-5" strokeWidth={1.6} />
            <span>{t.label}</span>
          </button>
        );
      })}
    </aside>
  );
}

export { TABS };
